import React from "react";
import SingleUserContent from "../components/users/single-user-content";

const SingleUser = () => {
  return <SingleUserContent />;
};

export default SingleUser;
